import classes from "../CustomInputs.module.css";
import { useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import { Button } from "@mui/material";
import Strings from "../../../../resources/Strings";
import { getBase64 } from "../../../../utils/CommonUtils";
import { InputInfo } from "../../../../entities/UIEntities/Form Entities/InputInfo";
import { getExtensionFileNameToLowerCase } from "../../../../utils/MenuUtils";

const AttachmentInput = forwardRef((props, ref) => {
  const fileInput = useRef(null);

  const handleFileChange = (event) => {
    const { name } = event.target;
    const newFile = event.target?.files?.[0];
    
    if (newFile) {
      // Renames the extension of the file name to lower case
      Object.defineProperty(newFile, 'name', {
        writable: true,
        value: getExtensionFileNameToLowerCase(newFile.name)
      });

      getBase64(newFile, (result) => {
        props.onChange({[name]: [newFile, result] });
      });
    }
  };

  const handleFileClear = () => {
    fileInput.current.value = ''; // clears attached file data from input
    props.onChange({[props.id]: [] });
  };

  useImperativeHandle(ref, () => ({
    handleFileClear
  }));

  useEffect(() => {
    if (props.handleError) {
      props.handleError({ [props.id]: props.hasError });
    }
    if (props.handleInputInfo) {
      props.handleInputInfo(new InputInfo(props.id, props[props.id], props.isRequired, props.hasError));
    }
  }, [props[props.id]?.length > 0]);

  return (
    <div className={classes.uploadImageInput}>
      <input
        accept={props.accept}
        hidden
        id={props.id}
        name={props.id}
        type="file"
        onChange={handleFileChange}
        ref={fileInput}
      />
      <label htmlFor={props.id} className={classes.action}>
        <Button className={classes.formButton} component="span">
            {props.attachment.length > 0 ? `Edit ${Strings.INPUT_LABELS.ATTACHMENT}` : `Add ${Strings.INPUT_LABELS.ATTACHMENT}`}
        </Button>
      </label>
    </div>
  );
}); // added ) - for forward ref

export default AttachmentInput;
